<template>
  <div class="box__create" id="modal_create">
    <div class="create__content">
      <div class="create__header">
          <img class="__title" :src="`/internacional/public/emails-app/email-icon.svg`"/> <span class="__title" v-text="t.label_create_email"></span>
          <span class="__close" @click="$emit('hide')" data-ba-i="close-create-email-modal">&times;</span>
      </div>
      <div class="create__body">
          <div class="email__row">
              <div class="email__col">
                  <label v-text="t.email" v-bind:class="label_email"></label><br/>
                  <input type="text" v-model="email" v-bind:class="input_email" @click="clickInputEmail()">
              </div>  
              <div class="email__col">
                  <label >&nbsp;</label><br/>
                  <input type="text" readonly v-model="input_domain">
              </div>      
          </div> 
          <div v-if="empty_email" class="info__span" v-text="t.required"></div>

          <div class="password__row">
              <div class="password__col">
                  <label  v-text="t.password" v-bind:class="label_password2"></label><br/>
                  <input type="password" v-model="password" v-bind:class="input_password" @click="clickInputPassword()">
                  <div class="box-help-text-inputs">
                    <div>
                      <div v-if="!passwords_match && !empty_password" class="info__span" v-text="t.pass_do_not_match"></div>
                      <div v-else-if="empty_password" class="info__span" v-text="t.required"></div>
                    </div>
                    <p v-if="password" :class="[password.length < 10 ? 'red-color' : 'green-color']" v-text="password.length"></p>
                  </div>
              </div>

              <div class="password__col">
                  <label v-text="t.label_confirmar_senha" v-bind:class="label_password2"> </label><br/>
                  <input type="password"  v-model="password2" v-bind:class="input_password2">
                  <div class="box-help-text-inputs">
                    <div></div>
                    <p v-if="password2" :class="[password2.length < 10 ? 'red-color' : 'green-color']" v-text="password2.length"></p>
                  </div>
              </div>
          </div> 
            
      <div class="progress__row">
        <label v-text="t.office_email_password_strength"> </label><br/>
        <div v-bind:class="progress_passwordStrength">
          <div v-bind:class="progress_bar" role="progressbar" v-bind:aria-valuenow="passwordStrength" aria-valuemin="0" aria-valuemax="100" :style="'width:' +passwordStrength+'%'"> <span style="vertical-align: sub;" v-text="passwordStrength + '%'"/> </div>
        </div>
      </div>
      <div class="info__span" v-text="t.password_strength_100"></div>
      </div>
      <div class="create__footer">
          <button v-bind:class="buttn_create" v-html="t.label_criar" @click="add()" data-ba-i="save-create-email"></button>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
    import qs from "qs";
    import punycode from "punycode";
    export default {
    name: "create-email",
    props: ["domain", "translations", "handlers", "show"],
    data() {
        return {
        	h: this.handlers,
        	t: this.translations,
          email: "",
          password: "",
          password2: "",
          passwordStrength: 0,
          input_domain : "@",
          processing: false,

          //flags
          passwords_match: true,  
          empty_email: false,  
          empty_password: false,  

          // classes
          label_email: "",
          label_password: "",
          label_password2: "",
          input_email: "",
          input_password: "",
          input_password2: "",
          progress_passwordStrength: "progress",
          buttn_create : "btn button3 btn__create",
          progress_bar: "progress-bar progress-low"
        };
    },
    watch:{
      email(newValue, oldValue){
        if(!newValue){
          this.empty_email = true
          this.input_email = "wrong__input"
        }else{
          this.empty_email = false
          this.input_email = ""
        }
      },
      password2(newValue, oldValue){
        let vm = this
        if(vm.password){
          if(this.password === this.password2){
            vm.passwords_match = true
            vm.input_password  = ""
            vm.input_password2 = ""
          } else {
            vm.passwords_match = false
            vm.input_password  = "wrong__input"
            vm.input_password2 = "wrong__input"
          }
        }
      },
      password(newValue, oldValue){
        this.passwordStrength = this.getPasswordStrength(newValue)
        this.empty_password = false
          if(this.passwordStrength <= 66){
            this.progress_bar = "progress-bar progress-low"
          }else if(this.passwordStrength <= 99){
            this.progress_bar = "progress-bar progress-medium"
          }else{
            this.progress_bar = "progress-bar progress-high"
        }

        if(newValue){
          this.passwords_match = false
          if(this.password === this.password2){
            this.passwords_match = true
            this.input_password  = ""
            this.input_password2 = ""
          } else {
            this.passwords_match = false
            this.input_password  = "wrong__input"
            this.input_password2 = "wrong__input"
          }
        } else {
          this.passwords_match = true
          this.empty_password = true
          this.input_password = "wrong__input"
        }
      },
      show(){
        this.email = ""
          this.password = ""
          this.password2 = ""
          this.input_domain = this.toUnicode("@" + this.domain.domain, false)

          this.passwords_match = true  
          this.empty_email = false 
          this.empty_password = false  

          this.label_email = ""
          this.label_password = ""
          this.label_password2 = ""
          this.input_email = "",
          this.input_password = ""
          this.input_password2 = ""
          this.progress_passwordStrength = "progress"
          this.buttn_create = "btn button3 btn__create"

          this.processing = false

      },
    },
    methods: {
      clickInputEmail(){
        if(!this.email){
          this.empty_email = true
          this.input_email = "wrong__input"
        }else{
          this.empty_email = false
          this.input_email = ""
        }
      },
      clickInputPassword(){
        if(!this.password){
          this.empty_password = true
          this.input_password = "wrong__input"
        }else{
          this.empty_password = false
          this.input_password = ""
        }
      },
      isValidForm(){
        this.clickInputEmail()
        this.clickInputPassword()

        if(this.passwords_match && !this.empty_email && !this.empty_password && this.passwordStrength >= 100)
        {
          return true;
        }
        else
        {
          return false;
        }
      },
      add(){
        if(!this.processing && this.isValidForm()){
          this.addEmail()
        }
      },
      addEmail(){
        let load = $.dialog({
            title: false,
            content: '',
            type: 'blue',
            onOpen: function () {
              load.showLoading(true)
          },
        });
        
        let vm = this
        vm.processing = true
        axios
            .post(
                vm.h.routes.create,
                qs.stringify({domain: vm.domain.domain, email: vm.email, password: vm.password})
            )
            .then(function(response) {
                if(response.data.status){
                  $.alert({
                      title: vm.t.label_success,
                      content: response.data.data,
                      type: 'green',
                  });
                  vm.$emit('created')
                }else{
                  $.alert({
                      title: vm.t.label_error,
                      content: response.data.data,
                      type: 'red',
                  });
                }
            })
            .catch(function(error) {

            })
            .finally(function(){
              vm.processing = false
              load.close()
            });
      },
      getPasswordStrength(password){
        let strength = 0
        const regex_minusculas = /[a-z]/
        const regex_maiusculas = /[A-Z]/
        const regex_numeros    = /\d/
        const regex_special    = /[^a-zA-Z\d]/

          //Se contém um caractere minúsculo: soma 20
          if(regex_minusculas.exec(password) !== null)
            strength += 20

          //Se contém um caractere maiúsculo: soma 20
          if(regex_maiusculas.exec(password) !== null)
            strength += 20

          //Se contém um número: soma 20
          if(regex_numeros.exec(password) !== null)
              strength += 20

          //Se contém um caractere especial: soma 20
          if(regex_special.exec(password) !== null)
              strength += 20

          //Se a senha possuir 10 ou mais caracteres: soma 20
          //Se a senha possuir de 6 a 9 caracteres: soma 10
          if(password.length >= 10)
              strength += 20
          else if(password.length >= 6)
              strength += 10
          
        return strength
      },
      toUnicode(text, isEmail){

        if(!isEmail){
          return punycode.toUnicode(text)
        }else{
          let parts = text.split('@')
          return punycode.toUnicode(parts[0]) + '@' + punycode.toUnicode(parts[1]) 
        }
      },
  },
};
</script>

<style scoped lang="scss">
  $color-primary-light: rgba(102, 179, 255, 0.35);
  $color-wrong: #ff4d4d;

.box__create{
    color: #fff;
    background: #fff;
    transition: 0.5s;
    display: block;
    opacity: 1;
    z-index: 2040 !important;
    position: fixed;
    top: 54px;
    right: 0;
    bottom: 0;
    left: 0;
    margin-left: 2%;
    margin-right: 2%;
    overflow-y: auto;

    .create__content{
        
        background-color: var(--theme-color-primary);
        border-radius: 40px 40px 0px 0px;
        margin: 1rem 3rem;
        position: relative;

        .create__header{
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 100%;
            padding: 2.3rem 0;

            img{
              vertical-align: top;
              margin-right: 0.8rem;
              margin-left: 0.8rem;
              width: 2.8rem;
            }

            span{
              font-weight: bold;
              font-size: 1.7rem;
            }

            .__close{
              position: absolute;
              font-weight: normal;
              right: 29px;
              cursor: pointer;
            }
        }

        .create__body{
          margin-left:  15%;
          margin-right: 15%;
          margin-top: 4%;
          
          .email__row{
            display: grid;
            grid-template-columns: 1fr auto;
            gap: 3rem;
          }

          .password__row{
            display: grid;
            grid-auto-flow: column;
            gap: 3rem;
            padding-top: 3rem;

            .password__col{
              width: 100%;
              padding-top: 1rem;
              .box-help-text-inputs{
                display: flex;
                justify-content: space-between;
              }
            }
          }

          .progress__row{
            width: 100%;
            display: block;
            padding-top: 4rem;
          }
          
          input{
            width: 100%;
            border: 0;
            background-color: transparent;
            border-bottom: 1px solid #fff;
            font-size: .9rem;
            font-weight: bold;
            padding: 0.7rem 0;

            &:focus{
              border: 0;
              border-bottom: 1.5px solid #FAFF00;
              color:#FAFF00;
            }
          }
          
          textarea:focus, input:focus{
              outline: none;
          }
          .wrong__label{
              color: $color-wrong;
          }

          .wrong__input{
              border-bottom: 1.5px solid $color-wrong;
          }
        }

        .info__span{
          padding-top: 8px;
          font-style: italic;
          font-size: .9rem;
        }

        .create__footer{
            min-width: 100%;
            padding: 4rem 0;
            justify-content: center;
            display: flex;

            .btn__create{
              width: 15rem;
              font-size: 24px;
              border-radius: 2rem;
              opacity: 1;
              min-width: fit-content;
              background-color: rgba(255,255,255,0.5);

              &:focus-within{
                color: #fff !important;
              }
              

              img{
                vertical-align: top;
                margin-right: 0.8rem;
              }
            }
        }

        
      .__btn-disabled{
        cursor:not-allowed;
        opacity: 0.5;
      }
    }

    /* Progress Bar */

    .progress {
  height: 30px;
    overflow: hidden;
    // background-color: #fff;
    background-color: #E5E5E5;
    margin-top: .5rem;
    margin-bottom: 0;
    border-radius: 15px;
  }

  .progress-bar{
    color: #fff;
    font-size: 20px;
  }

  .progress-wrong{
      border: 1.5px solid #ff4d4d;
  }

  .progress-low{
    background-color: #66B3FF;
  }

  .progress-medium{
    background-color: #FF9900;
  }

  .progress-high{
    background-color: #00FF28;
  }

}
.red-color{
  color: #ff4d4d;
}
.green-color{
  color: #00FF28;
}
  
@media screen and (min-width: 1200px) {
  .create__content {
    max-width: 1000px;
    margin: 1rem auto !important;
  }
}
@media screen and (max-width: 900px) {
  .box__create{
    .create__content {
      margin: 0;
      border-radius: 1rem;
      height: unset;
    }
    .create__body{
      margin-left:  5% !important;
      margin-right: 5%  !important;
    }
    .email__row, .password__row{
      gap: 1rem !important;
      grid-auto-flow: row !important;
    }
  }
  .password__row {
    grid-auto-flow: column;
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/emails-app/create-email.vue